import React from 'react'

import { Formik } from 'formik'
import Yup from '_zari/validation/_yup'

import { Button, Form, Modal } from '_zari/core'

import ListaMonedasConstant from 'constants/listaDeMonedas'
import CondicionesPagoConstant from 'constants/condicionesDePago'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  fecha: Yup.string().required(),
  moneda: Yup.string().required(),
  cuentaContable: Yup.string().required(),
  importe: Yup.number().required(),
  medioPago: Yup.string().required(),
  tipoCambio: Yup.number().required(),
  flujoEfectivo: Yup.string().required()
})

// TODO > Constantes en medio de pago
const FormularioPagos = ({ show, handleClose, mainFormData, idEdicion, submitFunction }) => {
  const formInitialValues = React.useMemo(() => {
    return {
      condicionPago: CondicionesPagoConstant.CONTADO,
      fecha: mainFormData.fechaEmision,
      moneda: mainFormData.moneda,
      cuentaContable: '',
      importe: mainFormData.importeTotal,
      medioPago: '008',
      numeroDocumento: '',
      tipoCambio: 1,
      flujoEfectivo: 'O050'
    }
  }, [mainFormData])

  const submitHandler = (data, { setSubmitting }) => {
    mainFormData.condicionPago = data.condicionPago
    mainFormData.pago = data

    submitFunction(mainFormData, setSubmitting, idEdicion)
  }

  return (
    <Modal show={show} onHide={handleClose} centered size='sm'>
      <Modal.Header>
        <Modal.Title>PAGO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CondicionPagoFormGroup
                iValue={values.condicionPago}
                fIsSubmitting={isSubmitting}
                iError={errors.condicionPago}
                iTouched={touched.condicionPago}
              />
              {values.condicionPago !== CondicionesPagoConstant.CREDITO && (
                <>
                  <FormGroups.FechaFormGroup fIsSubmitting={isSubmitting} iError={errors.fecha} iTouched={touched.fecha} />
                  <FormGroups.MonedaFormGroup fIsSubmitting={isSubmitting} iError={errors.moneda} iTouched={touched.moneda} />
                  <FormGroups.CuentaContableFormGroup
                    iMonedaValue={values.moneda}
                    fIsSubmitting={isSubmitting}
                    iError={errors.cuentaContablePago}
                    iTouched={touched.cuentaContablePago}
                    setFieldValue={setFieldValue}
                  />
                  <FormGroups.ImporteFormGroup iValue={values.importe} />
                  <FormGroups.MedioPagoFormGroup fIsSubmitting={isSubmitting} iError={errors.medioPago} iTouched={touched.medioPago} />
                  <FormGroups.NumeroDocumentoFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors.numeroDocumento}
                    iTouched={touched.numeroDocumento}
                  />
                  {values.moneda === ListaMonedasConstant.DOLARES && (
                    <FormGroups.TipoCambioFormGroup
                      iFechaValue={values.fecha}
                      iMonedaValue={values.moneda}
                      setFieldValue={setFieldValue}
                      fIsSubmitting={isSubmitting}
                      iError={errors.tipoCambio}
                      iTouched={touched.tipoCambio}
                    />
                  )}
                  <FormGroups.FlujoEfectivoFormGroup fIsSubmitting={isSubmitting} iError={errors.flujoEfectivo} iTouched={touched.flujoEfectivo} />
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Procesar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default FormularioPagos
